const CALL_RETURN_PATH_KEY = 'videocall.callReturnPath';

function isCallRoute(path: string): boolean {
  return path === '/call' || path.startsWith('/call/');
}

export function rememberCallReturnPath(path: string | null | undefined): void {
  const value = (path || '').trim();
  if (!value || isCallRoute(value)) return;
  try {
    sessionStorage.setItem(CALL_RETURN_PATH_KEY, value);
  } catch {
    // ignore storage failures
  }
}

export function consumeCallReturnPath(fallback = '/messages'): string {
  try {
    const raw = sessionStorage.getItem(CALL_RETURN_PATH_KEY) || '';
    sessionStorage.removeItem(CALL_RETURN_PATH_KEY);
    const value = raw.trim();
    if (!value || isCallRoute(value)) return fallback;
    return value;
  } catch {
    return fallback;
  }
}

export function peekCallReturnPath(fallback = '/messages'): string {
  try {
    const raw = sessionStorage.getItem(CALL_RETURN_PATH_KEY) || '';
    const value = raw.trim();
    if (!value || isCallRoute(value)) return fallback;
    return value;
  } catch {
    return fallback;
  }
}
